import { Component } from '@angular/core';

import { ModalComponent } from '../modal/modal.component';
import { BaseMenuComponent } from './base.menu';

@Component({
  selector: 'inspection-list-menu',
  templateUrl: './inspection-list.menu.html',
  standalone: false
})
export class InspectionListMenuComponent extends BaseMenuComponent {
  constructor(public modal: ModalComponent) {
    super(modal);
  }
}
